import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import config from 'config'

import styles from './prejoin.module.css'

export type ContinueInAppProps = {
  meetingCode: string
  isHandheld: boolean
}

export function ContinueInApp({ meetingCode, isHandheld }: ContinueInAppProps) {
  const { t } = useTranslation()
  const [isOffered, setIsOffered] = useState(isHandheld)

  useEffect(() => {
    if (!isHandheld && navigator.maxTouchPoints > 1) {
      setIsOffered(true)
    }
  }, [isHandheld])

  const scheme = config.appScheme

  if (!isOffered || !scheme) {
    return null
  }

  return (
    <a className={styles.continueInApp} href={`${scheme}://m/${meetingCode}`}>
      {t('chat.call.prejoin.continueInApp')}
    </a>
  )
}
